import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M12.5,11 L12.5,5 L11,5 L11,3.5 L5,3.5 L5,5 L3.5,5 L3.5,11 L5,11 L5,12.5 L11,12.5 L11,11 L12.5,11 Z M13.5,11 L15,11 L15,15 L11,15 L11,13.5 L5,13.5 L5,15 L1,15 L1,11 L2.5,11 L2.5,5 L1,5 L1,1 L5,1 L5,2.5 L11,2.5 L11,1 L15,1 L15,5 L13.5,5 L13.5,11 Z M4,4 L4,2 L2,2 L2,4 L4,4 Z M12,4 L14,4 L14,2 L12,2 L12,4 Z M2,14 L4,14 L4,12 L2,12 L2,14 Z M12,14 L14,14 L14,12 L12,12 L12,14 Z"/>
  </svg>
);
